import { useEffect, useState } from "react";

/**
 * Custom hook to manage sticky navigation positioning
 * Calculates the parent element height for proper sticky nav positioning
 */
export const useStickyNavPosition = (parentRef?: React.RefObject<HTMLElement | null>) => {
    const [stickyNavStartY, setStickyNavStartY] = useState(0);

    useEffect(() => {
        const calculateStickyNavPosition = () => {
            if (!parentRef?.current) return;

            const parentHeight = parentRef.current.offsetHeight;
            setStickyNavStartY(parentHeight);
        };

        const handleResize = () => {
            requestAnimationFrame(calculateStickyNavPosition);
        };

        calculateStickyNavPosition();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [parentRef]);

    return { stickyNavStartY };
};